

<div class="card py-10 ">

  <button routerLink="/auth/login" ejs-button
    class="dl-button h-8 mb-5">
    <svg viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
      class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
    </svg>
  </button>

  <div class="w-full flex flex-col items-center justify-center">
    <div class="text-center w-full">
      <h2 class=" text-bold ">Reset password</h2>
      <h5 class=" text-bold ">Inserisci l'email associata al tuo account</h5>
    </div>

    <div [formGroup]="formReset" class="w-11/12 mt-8">

      <div class="relative mb-2 text-center ">
        <!-- <label for="email" class="text-gray-500">Email</label> -->
        <input #email id="email" formControlName="email"
          class="e-input transform duration-300"
          (keyup)="mailValidation(email.value)" placeholder="Inserisci l'email " />
        <ejs-message class="msg w-full" severity="Error"
          [visible]="mailNotValid"
          [content]="'La mail inserita non è valida'"></ejs-message>
        <ejs-message class="msg w-full" severity="Error" [visible]="mailExists"
          [content]="'Esiste già un utente con questa email'"></ejs-message>
      </div>

      <div class=" my-6">
        <button ejs-button class="e-primary transform duration-300"
          (click)="otp()">
          Continua
        </button>
      </div>

      <ejs-message class="msg w-full" severity="Error"
        [visible]="formHaveErrors" >Errore nel reset della password, riprova o contatta un amministratore</ejs-message>

      <ejs-message *ngIf="rispReset" class="msg w-full" severity="Error"
        [visible]="!rispReset.success"
        [content]="rispReset.error"></ejs-message>
    </div>

  </div>
</div>